module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./TaskManageView.js"));
	}, "taskManageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=taskManageView!./src/pages/DispatchCenter/TaskManage/TaskManageView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=taskManageView!./src/pages/DispatchCenter/TaskManage/TaskManageView.js
// module chunks = 43